import React, {useEffect, useState} from "react";
import {Backdrop, Box, CircularProgress} from "@mui/material";
import {ClickToQuestion} from "./types/ClickToQuestion";
import SiNoQuestion from "./types/SiNoQuestion";
import {SendPhotoQuestion} from "./types/SendPhotoQuestion";
import SentimentQuestion from "./types/SentimentQuestion";
import QuizQuestion from "./types/QuizQuestion";
import WordcloudQuestion from "./types/WordcloudQuestion";
import ToolpressQuestion from "./types/ToolpressQuestion";
import {useParams} from "react-router-dom";
import {auth, firestore} from "../../firebase/clientApp";
import axios from "axios";
import {API_URL} from "../../config";
import {AltroQuestion} from "./types/AltroQuestion";
import {AudioQuestion} from "./types/AudioQuestion";
import findAnswered from "../../functions/findAnswered";
import findAnswer from "../../functions/findAnswer";
import ReorderQuestion from "./types/ReorderQuestion";
import ReserveSpot from "./types/ReserveSpot";
import LinksQuestion from "./types/LinksQuestion";
import ColorQuestion from "./types/ColorQuestion";
import TextQuestion from "./types/TextQuestion/TextQuestion";
import PhotoGallery from "./types/PhotoGallery";
import ColorQuizQuestion from "./types/ColorQuizQuestion";
import PhotoPollQuestion from "./types/PhotoPollQuestion";
import findAnswers from "../../functions/findAnswers";
import PhotoMultiPollQuestion from "./types/PhotoMultiPollQuestion";

export const QuestionSwitch = ({elementPlaying, theme}) => {
    const {eventOwnerId, id} = useParams()

    const [answer,setAnswer] = useState('')

    const [answers, setAnswers] = useState([])

    const [answered, setAnswered] = useState(false)
    const [sending, setSending] =useState(false)
    const [success, setSuccess] =useState(false)
    const user = auth.currentUser

    useEffect(()=> {
        findAnswered(eventOwnerId, id, elementPlaying, user)
            .then(answered => {
                setAnswered(answered)
            })
        if(elementPlaying.tipo === 'multiPoll') {
            findAnswers(eventOwnerId, id, elementPlaying, user)
                .then(answers => {
                    setAnswers(answers)
                })
        } else {
            findAnswer(eventOwnerId, id, elementPlaying, user)
                .then(answer => {
                    setAnswer(answer)
                })
        }

    },[elementPlaying])

    function sendAnswer(receivedAnswer) {
        let data = {
            answer: receivedAnswer,
            user: user.uid
        }
        setSuccess(false)
        setSending(true)
        axios.post(`${API_URL}users/${eventOwnerId}/answer/${id}/${elementPlaying.id}`, data)
            .then(response => {
                setSuccess(true)
                setAnswered(true)
                setSending(false)
                setAnswer(receivedAnswer)
            })
            .catch( error => {
                setSending(false)
            })
    }

    const commonProps = {
        sendAnswer: sendAnswer,
        answer: answer,
        sending: sending
    };

    const componentProps = {
        'clickTo': { element: elementPlaying },
        'color': { element: elementPlaying },
        'links': { elementId: elementPlaying.id, risposte: elementPlaying.risposte, risposteTranslations: elementPlaying.risposteTranslations, },
        'text': { textContent: elementPlaying.textContent, },
        'siNo': { tipo: elementPlaying.tipo, ...commonProps },
        'sendPhoto': { elementId: elementPlaying.id, ...commonProps },
        'sentiment': { tipo: elementPlaying.tipo, theme: theme, ...commonProps },
        'quiz': { risposte: elementPlaying.risposte, risposteTranslations: elementPlaying.risposteTranslations, corretta: elementPlaying.corretta, hideResult: elementPlaying.hideResult, ...commonProps },
        'poll': { risposte: elementPlaying.risposte, risposteTranslations: elementPlaying.risposteTranslations, isPoll: true, ...commonProps },
        'colorPoll': { risposte: elementPlaying.risposte, risposteTranslations: elementPlaying.risposteTranslations, isPoll: true, ...commonProps },
        'imagePoll': { risposte: elementPlaying.risposte, risposteTranslations: elementPlaying.risposteTranslations, isPoll: true, ...commonProps },
        'multiPoll': { risposte: elementPlaying.risposte, risposteTranslations: elementPlaying.risposteTranslations, isPoll: true, answers: answers, votesNumber: elementPlaying.votesNumber, ...commonProps },
        'imageQuiz': { risposte: elementPlaying.risposte, risposteTranslations: elementPlaying.risposteTranslations, isPoll: false, hideResult: elementPlaying.hideResult, ...commonProps },
        'reorder': { risposte: elementPlaying.risposte, risposteTranslations: elementPlaying.risposteTranslations, isPoll: true, ...commonProps },
        'wordcloud': { elementId: elementPlaying.id, tipo: elementPlaying.tipo, wordsNumber: elementPlaying.wordsNumber, answered: answered, success: success, ...commonProps },
        'toolpress': { elementPlaying: elementPlaying },
        'audio': { elementId: elementPlaying.id, ...commonProps },
        'reserveSpot': { elementPlaying: elementPlaying, answer: answer, answered: answered, success: success, ...commonProps },
        'photoGallery': {elementPlaying: elementPlaying},
        'altro': { elementPlaying: elementPlaying, user: user},
    };

    const componentMap = {
        'clickTo': ClickToQuestion,
        'color': ColorQuestion,
        'links': LinksQuestion,
        'text': TextQuestion,
        'siNo': SiNoQuestion,
        'sendPhoto': SendPhotoQuestion,
        'sentiment': SentimentQuestion,
        'quiz': QuizQuestion,
        'poll': QuizQuestion,
        'colorPoll': ColorQuizQuestion,
        'imagePoll': PhotoPollQuestion,
        'imageQuiz': PhotoPollQuestion,
        'multiPoll': PhotoMultiPollQuestion,
        'reorder': ReorderQuestion,
        'wordcloud': WordcloudQuestion,
        'toolpress': ToolpressQuestion,
        'reserveSpot': ReserveSpot,
        'audio': AudioQuestion,
        'photoGallery': PhotoGallery,
        'altro': AltroQuestion,
    };

    return(
        <Box>
            <Backdrop
                sx={{ color: '#f1ebe9', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={sending}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {
                componentMap[elementPlaying.tipo]
                        ? React.createElement(componentMap[elementPlaying.tipo], componentProps[elementPlaying.tipo])
                        : null

            }
        </Box>
    )
}